import { Table } from '@mantine/core';
import PublishRowTableRows from './publishtablerows';
import Usegetblogs from '../hooks/usegetblogdata';
import { ReactComponent as NoBlogIcon } from 'assets/icons/noBlogicon.svg';

const DeletedStories = ({ searchText, filterValue }) => {
  const blogData = Usegetblogs({
    isDeleted: 'True',
    isDraft: 'False',
    isPublished: null,
    searchText: searchText,
    filterValue: filterValue,
  });

  return (
    <>
      {blogData?.data?.data.length === 0 ? (
        <div className='bg-[#fff] min-h-[72vh] rounded-xl shadow-2xl p-4 flex justify-center items-center flex-col'>
          <NoBlogIcon />
          <p className='text-[#535353] mt-4 text-base'>
            Seems like you have no stories in delete section
          </p>
        </div>
      ) : (
        <div className='bg-[#fff] min-h-[70vh] rounded-xl shadow-2xl mt-5'>
          <Table verticalSpacing='lg' highlightOnHover>
            <thead>
              <th className='bg-[#FFE8E1] rounded-tl-xl py-4 w-[250px]'>
                Submitted by
              </th>
              <th className='bg-[#FFE8E1]'>Topic</th>
              <th className='bg-[#FFE8E1] pl-10' style={{ textAlign: 'left' }}>
                Story preview
              </th>
              <th className='bg-[#FFE8E1]'></th>
              <th className='bg-[#FFE8E1] rounded-tr-xl '>Action</th>
            </thead>
            <tbody className=' w-full max-h-20 border-none'>
              {/* <PublishRowTableRows /> */}
              {blogData?.data?.data.length === 0 ? null : (
                <>
                  {blogData?.data?.data?.map((eachBlog) => (
                    <PublishRowTableRows
                      key={eachBlog.id}
                      data={eachBlog}
                      name='Delete'
                    />
                  ))}{' '}
                </>
              )}
            </tbody>
          </Table>
        </div>
      )}
    </>
  );
};

export default DeletedStories;
